// extracted by mini-css-extract-plugin
export default {"docsContainer":"style_docsContainer__t+nos","header":"style_header__CoSfw","list":"style_list__El3Sp","footer":"style_footer__JKrhg"};